/**
 * Imputation status options: default tenants use TERMINE/ECHEC; RS tenant uses a seven-step workflow.
 */
export const DEFAULT_ETAT_OPTIONS = [
  { value: 'TERMINE', label: 'Accomplished ( Réalisé )' },
  { value: 'ECHEC', label: 'Failed ( Échec )' },
];

export const RS_ETAT_OPTIONS = [
  { value: 'TO_DO', label: 'To do' },
  { value: 'QUALIFIED', label: 'Qualified' },
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'SOURCED', label: 'Sourced' },
  { value: 'TO_PROPOS', label: 'To Propos' },
  { value: 'PROPOSED', label: 'Proposed' },
  { value: 'PRESENTED', label: 'Presented' },
  { value: 'FINAL', label: 'Final' },
  { value: 'COMPLETED', label: 'Completed' },
];

export const RS_ETAT_CODES = RS_ETAT_OPTIONS.map((o) => o.value);

/** KPI / charts: completed success state */
export function getCompletedEtatCode(tenantSubdomain) {
  return (tenantSubdomain || '').toLowerCase() === 'rs' ? 'COMPLETED' : 'TERMINE';
}

export function getImputationEtatOptions(tenantSubdomain) {
  return (tenantSubdomain || '').toLowerCase() === 'rs' ? RS_ETAT_OPTIONS : DEFAULT_ETAT_OPTIONS;
}

export function getDefaultEtatForNewImputation(tenantSubdomain) {
  return (tenantSubdomain || '').toLowerCase() === 'rs' ? 'TO_DO' : 'TERMINE';
}

/** Filter dropdown: first option is "All" */
export function getImputationEtatFilterOptions(tenantSubdomain) {
  return [{ value: '', label: 'All' }, ...getImputationEtatOptions(tenantSubdomain)];
}

const RS_BADGE_CLASSES = {
  TO_DO: 'bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-900/40 dark:text-slate-200 dark:border-slate-600/70',
  QUALIFIED: 'bg-cyan-50 text-cyan-800 border-cyan-200 dark:bg-cyan-900/40 dark:text-cyan-200 dark:border-cyan-700/70',
  IN_PROGRESS: 'bg-sky-50 text-sky-800 border-sky-200 dark:bg-sky-900/40 dark:text-sky-200 dark:border-sky-700/70',
  SOURCED: 'bg-violet-50 text-violet-800 border-violet-200 dark:bg-violet-900/40 dark:text-violet-200 dark:border-violet-700/70',
  TO_PROPOS: 'bg-yellow-50 text-yellow-800 border-yellow-200 dark:bg-yellow-900/40 dark:text-yellow-200 dark:border-yellow-700/70',
  PROPOSED: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-700/70',
  PRESENTED: 'bg-indigo-50 text-indigo-800 border-indigo-200 dark:bg-indigo-900/40 dark:text-indigo-200 dark:border-indigo-700/70',
  FINAL: 'bg-orange-50 text-orange-800 border-orange-200 dark:bg-orange-900/40 dark:text-orange-200 dark:border-orange-700/70',
  COMPLETED: 'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-900/40 dark:text-emerald-200 dark:border-emerald-700/70',
};

const DEFAULT_BADGE_CLASSES = {
  TERMINE: 'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-900/40 dark:text-emerald-200 dark:border-emerald-700/70',
  ECHEC: 'bg-red-50 text-red-700 border-red-100 dark:bg-red-900/40 dark:text-red-200 dark:border-red-700/70',
  EN_ATTENTE: 'bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-700/70',
  ANNULE: 'bg-gray-100 text-gray-600 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600',
};

export function getEtatBadgeClasses(etat, tenantSubdomain) {
  const isRs = (tenantSubdomain || '').toLowerCase() === 'rs';
  if (isRs && RS_BADGE_CLASSES[etat]) return RS_BADGE_CLASSES[etat];
  return DEFAULT_BADGE_CLASSES[etat] || 'bg-gray-50 text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-200';
}

export function getEtatLabel(etat, tenantSubdomain) {
  const opts = getImputationEtatOptions(tenantSubdomain);
  const found = opts.find((o) => o.value === etat);
  return found ? found.label : etat;
}
